<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="50px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="名称" )
                  el-input.inputWidth(v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="日期")
                  el-date-picker.inputWidth(style='width:200px;' v-model='dataForm.checkonTime' value-format="yyyy-MM-dd" type="date" clearable)
              el-col(:md='6' :sm="24")
                el-form-item(label="时段")
                  el-time-select(style='width:115px' v-model='dataForm.startTime' :picker-options="{start: '00:00',step: '01:00',end: '23:00'}" )
                  font &nbsp;—&nbsp;
                  el-time-select(style='width:115px' v-model='dataForm.endTime' :picker-options="{start: dataForm.startTime,step: '01:00',end: '24:00',minTime:dataForm.startTime}" )
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle(null)'   type='primary' v-if="isAuth('px:attendance:add')"  ) 新建
                el-button( type='danger' @click='deleteitem(dataListSelections)' :disabled='dataListSelections.length <= 0' v-if="isAuth('px:attendance:detel')" ) 删除
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='name',header-align='center',align='center',label='标题')
            el-table-column(prop='checkonTime',header-align='center',align='center',label='日期')
            el-table-column(prop='startTime', header-align='center',align='center',label='开始时段' :show-overflow-tooltip='true')
            el-table-column(prop='endTime', header-align='center',align='center',label='结束时段' :show-overflow-tooltip='true')
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="addOrUpdateHandle(scope.row.id)"  type="text"  v-if="isAuth('px:attendance:update')" ) 修改
                                el-menu-item(index="1-2" @click='deleteitem(scope.row.id)'  v-if="isAuth('px:attendance:detel')" ) 删除
                                el-menu-item(index="1-3" @click='exportExcel(scope.row.id)' v-if="isAuth('px:group:upload')" ) 导出
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
</template>

<script>
import table from './table.js'
import AddOrUpdate from './add-or-update'
import commonData from '../common.js'

export default {
  name: 'single',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      pxType: commonData.pxType,
      dialogFormVisible: false,
      isCollapse: true,
      loading: null,
      gradeInfoVisible: false,
      gradeInfoDoubleVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
     // restaurants: [],
      dataForm: {
        matchName: null,
        name: null,
        checkonTime: '',
        startTime: '',
        endTime: '',
        title: null,
        userGroupId: null,
        level: null,
        ctType: null,
        applySize: null,
        projectType: null,
        matchStatus: null,
        matchStartTime: [],
        matchTime: []
      },
      levelOptions: [],
      sysOrgList: [],
      dataListSelections: [],
      levelDisabled: true
    }
  },
  components: {
    AddOrUpdate

  },
  mounted () {
    this.getDataList()
    //this.restaurants = this.loadAll();
    this.initCity()
    console.log(new Date('2019-11-11'.replace(/-/, '/')).getTime() > new Date().getTime())
    console.log(new Date().getTime())
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },

    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },

      queryList () {
        this.pageIndex = 1
        this.getDataList()
      },
    //添加或修改事件
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
  // 删除
    deleteitem (id) {
      if (typeof id !== 'string') {
        if (id.length == 0) return this.$message.error('未勾选任何项目！')
        let ids = []
        id.forEach(e => {
          ids.push(e.id)
        })
        id = ids.join()
      }
      this.$confirm('删除选中信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pxCheckon/delete/${id}`),
            method: 'get',
             params: this.$http.adornParams()
          }).then(data => {
            if (data && data.code === 0) {
              this.$message.success('删除成功!')
              this.getDataList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    exportExcel (id) {
        if (typeof id !== 'string') {
          if (id.length == 0) return this.$message.error('未勾选任何项目！')
          let ids = []
          id.forEach(e => {
            ids.push(e.id)
          })
          id = ids.join()
        }
        this.$confirm('确定导出相关连信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pxCheckon/getExportList/${id}`),
            method: 'get'
          }).then(data => {
            if (data && data.code === 0) {
              if (data.bean == null || data.bean.length === 0 || data.resultList == null || data.resultList.length === 0) {
                  this.$message.info('没有要导出的数据!')
                  return
              }
              let result = data.resultList
              result.forEach(e => {
                e.type = this.pxType[e.type]
                e.mbType = { '1': '注册会员', '2': '初始会员', '3': '荣誉会员' }[e.mbType]
                e.payStatus = {
                          0: '未支付', 1: '支付中', 2: '支付成功', 3: '支付失败', 4: '超时', 5: '申请退款', 6: '退款中', 7: '退款成功', 8: '退款失败', 9: '支付已关闭', 10: '退款已取消'
                          }[e.payStatus]
              })
              console.log('导出的数据：', result)
              this.$export.excel({
                  columns: this.table.columns,
                  data: result,
                  title: data.bean.name + '考勤信息' + data.bean.checkonTime
              }).then(() => {
                  this.$message.success('导出表格成功')
              })
      }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getDataList () {
        //this.dataForm.checkonTime + this.dataForm.startTime
        this.dataListLoading = true
        this.$http({
        url: this.$http.adornUrl('/pxCheckon/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.dataForm.name || null,
          checkonTime: new Date(this.dataForm.checkonTime).getTime() || null,
          startTime: this.dataForm.startTime || null,
          endTime: this.dataForm.endTime || null,
          limit: this.pageSize
        }
      }).then(data => {
        console.log(data)
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },

    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}
</style>
